import axios from 'axios';
import { handleRequestError } from 'requests/requestHandlers';

export const getServices = () => {
  return axios.get('/services')
    .then(res => res.data)
    .catch(res => handleRequestError(res, 'getServices'));
};
